import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};
export const remove = (ids) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/save',
    method: 'post',
    data: row,
  });
};

export const syncData = (param) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/sync',
    method: 'post',
    data: param,
  });
};
export const update = (row) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/submit',
    method: 'post',
    data: row,
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/list',
    method: 'get',
    params: {
      id,
    },
  });
};
export const getSpaceTree = (tenantId, communityGroup) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
    method: 'get',
    params: {
      tenantId,
      communityGroup,
    },
  });
};

//获取区域
export const loadRegionByParentId = (parentId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId',
    method: 'get',
    params: {
      parentId,
    },
  });
};
